import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FilterOption } from '../../../types/mpup-types'

@Component({
  selector: 'mb-mpup-filter',
  templateUrl: './mpup-filter.component.html',
  styleUrls: ['./mpup-filter.component.scss']
})
export class MpupFilterComponent {

  @Input()
  filterOptions!: ReadonlyArray<FilterOption>
  @Input()
  filterName!: string
  @Output()
  filter = new EventEmitter<string>()

  applyFilter (filterValue: string) {
    this.filter.emit(filterValue)
  }
}
